<template>
    <section id="features" class="section feature-story">
        <div class="feature-band feature-band-soft feature-practice-band">
            <div class="container">
                <div class="practice-heading">
                    <span class="feature-kicker">{{ $t('features.startBlock.label') }}</span>
                    <h2 v-html="$t('features.startBlock.title')"></h2>
                    <p>{{ $t('features.startBlock.desc') }}</p>
                </div>
                <div class="practice-steps">
                    <article v-for="(step, index) in startSteps" :key="index" class="practice-step">
                        <span class="practice-step-label">{{ step.label }}</span>
                        <h3>{{ step.title }}</h3>
                        <p>{{ step.desc }}</p>
                    </article>
                </div>
            </div>
        </div>

        <div class="feature-band">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-12 col-lg-6">
                        <FeatureCopy
                            :label="$t('features.receiptReady.label')"
                            :title="$t('features.receiptReady.title')"
                            :intro="$t('features.receiptReady.intro')"
                            :items="featurePointGroups.receiptReady"
                        />
                    </div>
                    <div class="col-12 col-lg-6">
                        <VisualPanel image="assets/img/feature/1.png" />
                    </div>
                </div>
            </div>
        </div>

        <div class="feature-band feature-band-soft">
            <div class="container">
                <div class="row align-items-center flex-lg-row-reverse">
                    <div class="col-12 col-lg-6">
                        <FeatureCopy
                            :label="$t('features.autoDetails.label')"
                            :title="$t('features.autoDetails.title')"
                            :intro="$t('features.autoDetails.intro')"
                            :items="featurePointGroups.autoDetails"
                        />
                    </div>
                    <div class="col-12 col-lg-6">
                        <VisualPanel image="assets/img/feature/2.png" />
                    </div>
                </div>
            </div>
        </div>

        <div class="feature-band">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-12 col-lg-6">
                        <FeatureCopy
                            :label="$t('features.globalReadyNew.label')"
                            :title="$t('features.globalReadyNew.title')"
                            :intro="$t('features.globalReadyNew.intro')"
                            :items="featurePointGroups.globalReady"
                        />
                    </div>
                    <div class="col-12 col-lg-6">
                        <VisualPanel image="assets/img/feature/3.png" />
                    </div>
                </div>
            </div>
        </div>

        <div class="feature-band feature-band-soft">
            <div class="container">
                <div class="row align-items-center flex-lg-row-reverse">
                    <div class="col-12 col-lg-6">
                        <FeatureCopy
                            :label="$t('features.multipleOrganizations.label')"
                            :title="$t('features.multipleOrganizations.title')"
                            :intro="$t('features.multipleOrganizations.intro')"
                            :items="featurePointGroups.multipleOrganizations"
                        />
                    </div>
                    <div class="col-12 col-lg-6">
                        <VisualPanel image="assets/img/feature/4.png" />
                    </div>
                </div>
            </div>
        </div>

        <div class="feature-band">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-12 col-lg-6">
                        <FeatureCopy
                            :label="$t('features.teamAccessNew.label')"
                            :title="$t('features.teamAccessNew.title')"
                            :intro="$t('features.teamAccessNew.intro')"
                            :items="featurePointGroups.teamAccess"
                        />
                    </div>
                    <div class="col-12 col-lg-6">
                        <VisualPanel image="assets/img/feature/5.png" />
                    </div>
                </div>
            </div>
        </div>

        <div class="feature-band feature-band-soft">
            <div class="container">
                <div class="row align-items-center flex-lg-row-reverse">
                    <div class="col-12 col-lg-6">
                        <FeatureCopy
                            :label="$t('features.easyExportsNew.label')"
                            :title="$t('features.easyExportsNew.title')"
                            :intro="$t('features.easyExportsNew.intro')"
                            :items="featurePointGroups.easyExports"
                        />
                    </div>
                    <div class="col-12 col-lg-6">
                        <VisualPanel image="assets/img/feature/6.png" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
const FeatureCopy = {
    props: {
        label: String,
        title: String,
        intro: String,
        items: Array
    },
    render(h) {
        return h('div', { class: 'feature-copy' }, [
            h('span', { class: 'feature-kicker' }, this.label),
            h('h2', { domProps: { innerHTML: this.title } }),
            h('p', { domProps: { innerHTML: this.intro } }),
            h('div', { class: 'feature-grid' }, this.items.map((item, index) => h('div', { class: 'feature-point', key: index }, [
                h('span'),
                h('div', [
                    h('h3', item[0]),
                    item[1] ? h('p', item[1]) : null
                ])
            ])))
        ])
    }
}

const VisualPanel = {
    props: {
        image: String
    },
    render(h) {
        return h('div', { class: 'visual-panel' }, [
            h('img', { attrs: { src: this.image, alt: '' } })
        ])
    }
}

export default {
    components: {
        FeatureCopy,
        VisualPanel
    },
    computed: {
        startSteps() {
            return [
                {
                    label: this.$t('features.startSteps.startFree'),
                    title: this.$t('features.startSteps.startFreeTitle'),
                    desc: this.$t('features.startSteps.startFreeDesc')
                },
                {
                    label: this.$t('features.startSteps.mailFile'),
                    title: this.$t('features.startSteps.mailFileTitle'),
                    desc: this.$t('features.startSteps.mailFileDesc')
                },
                {
                    label: this.$t('features.startSteps.support'),
                    title: this.$t('features.startSteps.supportTitle'),
                    desc: this.$t('features.startSteps.supportDesc')
                },
                {
                    label: this.$t('features.startSteps.oneAction'),
                    title: this.$t('features.startSteps.oneActionTitle'),
                    desc: this.$t('features.startSteps.oneActionDesc')
                }
            ]
        },
        featurePointGroups() {
            return {
                receiptReady: this.buildFeaturePoints('features.receiptReady.items'),
                autoDetails: this.buildFeaturePoints('features.autoDetails.items'),
                globalReady: this.buildFeaturePoints('features.globalReadyNew.items'),
                multipleOrganizations: this.buildFeaturePoints('features.multipleOrganizations.items'),
                teamAccess: this.buildFeaturePoints('features.teamAccessNew.items'),
                easyExports: this.buildFeaturePoints('features.easyExportsNew.items')
            }
        }
    },
    methods: {
        buildFeaturePoints(path) {
            return [0, 1, 2, 3].map((index) => {
                const title = this.$te(`${path}.${index}.title`) ? this.$t(`${path}.${index}.title`) : ''
                const desc = this.$te(`${path}.${index}.desc`) ? this.$t(`${path}.${index}.desc`) : ''
                return title ? [title, desc] : null
            }).filter(Boolean)
        }
    }
}
</script>

<style>
.feature-story {
    background: #fff;
}

.feature-band {
    padding: 90px 0;
}

.feature-band .container {
    max-width: 1100px;
    padding-left: 32px;
    padding-right: 32px;
}

.feature-band-soft {
    background: #f5f8fd;
}

.practice-heading {
    margin-bottom: 48px;
    max-width: 660px;
}

.practice-heading h2 {
    color: #111827;
    font-size: 38px;
    font-weight: 800;
    line-height: 1.18;
    margin-bottom: 18px;
}

.practice-heading h2 b {
    color: var(--blue3);
    font-weight: 800;
}

.practice-heading > p {
    color: #48556a;
    font-size: 16px;
    line-height: 1.75;
    margin: 0;
}

.practice-steps {
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(4, minmax(0, 1fr));
}

.practice-step {
    background: #fff;
    border: 1px solid #dbe5f2;
    border-radius: 16px;
    min-height: 220px;
    padding: 28px 24px;
}

.practice-step-label {
    color: var(--blue3);
    display: block;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.05em;
    margin-bottom: 16px;
    text-transform: uppercase;
}

.practice-step h3 {
    color: #0c2c6f;
    font-size: 17px;
    font-weight: 800;
    line-height: 1.35;
    margin-bottom: 8px;
}

.practice-step p {
    color: #647084;
    font-size: 13.5px;
    line-height: 1.65;
    margin: 0;
}

.feature-copy {
    max-width: 520px;
}

.feature-kicker {
    color: var(--blue);
    display: block;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0;
    margin-bottom: 16px;
    text-transform: uppercase;
}

.feature-copy h2 {
    max-width: 380px;
    color: #111827;
    font-size: 42px;
    font-weight: 800;
    letter-spacing: 0;
    line-height: 1.08;
    margin-bottom: 22px;
}

.feature-copy > p {
    max-width: 380px;
    color: #48556a;
    font-size: 16px;
    line-height: 1.75;
    margin-bottom: 34px;
}

.feature-grid {
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.feature-band-soft .feature-grid {
    grid-template-columns: 1fr;
}

.feature-point {
    display: grid;
    gap: 12px;
    grid-template-columns: 26px minmax(0, 1fr);
}

.feature-point span {
    align-items: center;
    background: var(--blue3);
    border-radius: 50%;
    box-shadow: 0 5px 14px rgba(7, 57, 234, 0.25);
    display: inline-flex;
    height: 26px;
    justify-content: center;
    width: 26px;
}

.feature-point span::before {
    color: #fff;
    content: "✓";
    font-size: 14px;
    font-weight: 800;
    line-height: 1;
}

.feature-point h3 {
    color: #172033;
    font-size: 16px;
    font-weight: 800;
    line-height: 1.25;
    margin-bottom: 7px;
}

.feature-point p {
    color: #647084;
    font-size: 13px;
    line-height: 1.55;
}

.visual-panel {
    align-items: center;
    display: flex;
    justify-content: left;
    min-height: 360px;
    overflow: hidden;
}

.visual-panel img {
    max-height: 82%;
    max-width: 82%;
    object-fit: contain;
}

@media (max-width: 991px) {
    .feature-band {
        padding: 70px 0;
    }

    .practice-steps {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .visual-panel {
        margin-top: 40px;
    }
}

@media (max-width: 767px) {
    .feature-band .container {
        padding-left: 22px;
        padding-right: 22px;
    }

    .practice-heading {
        margin-bottom: 34px;
    }

    .practice-heading h2 {
        font-size: 30px;
    }

    .feature-copy h2 {
        font-size: 32px;
    }

    .practice-steps {
        grid-template-columns: 1fr;
    }

    .practice-step {
        min-height: 0;
    }

    .visual-panel {
        min-height: 280px;
    }

    .feature-grid {
        grid-template-columns: 1fr;
    }
}
</style>
